<template>
  <li class="dropdown-submenu">
    <a href="#" @click.prevent="onClicked" :class="['dropdown-toggle', icon ? 'dropdown-menu-item-icon' : '']"><i v-if="icon" :class="['fal', icon]"></i> {{title}}</a>
    <ul class="dropdown-menu">
      <slot />
    </ul>
  </li>
</template>

<style>
.dropdown-submenu {
  position: relative;
}
.dropdown-submenu a::after {
  transform: rotate(-90deg);
  position: absolute;
  right: 5px;
  top: 40%;
}
.dropdown-submenu:hover .dropdown-menu, 
.dropdown-submenu:focus .dropdown-menu {
  display: flex;
  flex-direction: column;
  position: absolute !important;
  margin-top: -30px;
  left: 100%;
}
@media (max-width: 992px) {
  .dropdown-menu{
      width: 50%;
  }
  .dropdown-menu .dropdown-submenu{
      width: auto;
  }
}
</style>

<script>
export default {
  props: {
    title: String,
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>